import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Container as Grid } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import { creators as actionCreators } from '../../actions'
import actionProptypes from '../../actions/proptypes'

import Activity from '../../../shared/components/Activity'
import AutoFocus from '../../components/AutoFocus'
import ProgressArea from '../../components/ProgressArea'
import StudyPlanItem from '../../components/StudyPlanItem'
import StudentFAQ from '../../components/StudentFAQ'
import TipsForSuccessModal from '../../components/TipsForSuccessModal/tipsForSuccessModal.js'
import TopBar from '../../components/TopBar'
import FooterBar, { CenterRoundButton } from '../../components/FooterBar'
import ArgaErrorBar from '../ArgaErrorBar/argaErrorBar.js'
import Clickable from '../../components/Clickable'
import PreviewBar from '../../../shared/components/PreviewBar'
import CloseX from '../../../shared/components/CloseX'
import TextTruncate from '../../../shared/components/TextTruncate'

import LCSplitPane, { isVitalSourceURL } from '../../components/LCSplitPane'
import EbookSplitMobile from '../../components/EbookSplitMobile'
import EbookModal from '../../components/EbookModal'

import baseStyle from 'Styles/base.css'
import style from './style.css'
import panelStyle from 'Styles/panel.css'
import closeIcon from 'Assets/x-icon-blue.svg'

import params from '../../../client/lib/params'
import HowIsCalculatedModal from '../../components/Instructor/HowIsCalculatedModal'
import NetworkIssueModal from '../../components/NetworkIssueModal'
const { previewMode } = params(window.location.href)

class LandingPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      splitPane: false,
      splitLeftFooterWidth: '50%',
      howIsCalculatedModel: false
    }
  }

  componentWillMount () {
    // the activity may already have been loaded if coming from Instructor Page, so check first
    if (!this.props.activity) {
      this.props.actions.loadPreload().then(() => {
        this.props.actions.loadActivity(this.props.activityFile)
      })
    }
  }

  setDocumentTitle () {
    const {
      uiState,
      activity
    } = this.props

    if (activity) {
      const { activityTitle } = activity

      if (activityTitle && !uiState.showFaqPage) {
        document.title = `LearningCurve for ${activityTitle}`
      } else if (uiState.showFaqPage) {
        document.title = 'About LearningCurve'
      }
    }
  }

  onEditQuestionClick (fqUid) {
    window.opener && window.opener.FQ_Tool
      ? window.opener.FQ_Tool.activity_edit_question_from_preview(fqUid)
      : alert(`This action requires fq_tool.\nfq_uid: ${fqUid}`)
  }

  onFaqClick () {
    this.props.actions.faq()
  }

  onTipsClick () {
    this.props.actions.tipsForSuccess()
  }

  onActivityClick () {
    // clear any PSP ebook business
    this.onCloseEbook()
    this.props.actions.resumeActivity()
  }

  renderStartText () {
    if (this.props.previewMode) {
      return this.props.activity.score.activityScore ? 'Resume activity' : 'Begin activity'
    } else {
      return (this.props.activity.score.activityScore || this.props.paused) ? 'Resume activity' : 'Begin activity'
    }
  }

  onCloseEbook () {
    this.props.actions.closeSplitScreenEbookModal()
    this.setState({
      splitPane: false,
      EbookPspItem: false
    })

    this.props.uiState.isSplitScreenEbookDisplayed = false
    this.props.uiState.isLegacyEbookDisplayed = false
  }

  onToggleEbook (item) {
    const processOpen = item.displayValue !== undefined
    this.onCloseEbook()

    if (processOpen === true) {
      if (isVitalSourceURL(item.pageId) === true) {
        this.props.uiState.isSplitScreenEbookDisplayed = true
        this.setState({
          splitPane: true,
          EbookPspItem: item
        })
        this.props.uiState.isLegacyEbookDisplayed = false
      }
      this.props.actions.showPspEbook(item)
    }
  }

  onResizeSplit (newWidth) {
    this.setState({
      splitLeftFooterWidth: newWidth
    })
  }

  renderPersonalizedStudyPlan () {
    const splitPanelOverride = this.state.splitPane ? style.splitPanelOverride : ''
    // remove all study plan items that are not ebooks if we're using a standalone product
    return (
      <Col
        sm={this.props.browser.width === 768 ? 12 : 6}
        className={classnames(style.rightContent, style.panelContainer, splitPanelOverride)}
      >
        <div className={panelStyle.base}>
          <h2 className={style.studyPlanHeader}>
            Your Personalized Study Plan
          </h2>
          <p className={style.accuracyLabel}>Accuracy</p>
        </div>
        {this.renderTopics()}
      </Col>
    )
  }

  renderTopics () {
    return this.props.activity.topics.map((topic) => {
      return (
        <StudyPlanItem
          itemClick={this.onToggleEbook.bind(this)}
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={topic.totalPointsAvailable}
          totalPointsEarned={topic.totalPointsEarned}
          studyPlan={topic.studyPlan}
          disableLinks={this.props.activity.config.disableLinks}
          isActive={true}
        />
      )
    })
  }

  renderPreviewModeMeta () {
    const curCard = this.props.activity.score.curCard
    if (!curCard) {
      return null
    }

    const correctAnswer = curCard.questionType === 'FB' ? curCard.testTerm : curCard.choices[curCard.correctAnswerIndex]
    return (
      <ul className={classnames(baseStyle['hidden-md-down'], style.previewMeta)}>
        <li>Index: {this.props.activity.score.testModeCardCounter + 1} / {this.props.activity.questions.length} </li>
        <li>Topic: {curCard.topic.label}</li>
        <li>Level: {curCard.meta.level}</li>
        <li>Answer: {correctAnswer}</li>
        <li>
          <button
            className={'btn-cdl-main'}
            onClick={() => this.onEditQuestionClick(curCard.meta.fq_uid).bind(this)}
          >
            edit item
          </button>
        </li>
      </ul>
    )
  }

  renderInstructorButtons () {
    const { lessThan } = this.props.browser
    return (
      <div className={style.previewContainer}>
        <Grid>
          <Row>
            <Col>
              <span className={style.previewText}>Previewing as a Student</span>
              <Clickable
                className={classnames(style.endPreviewText, baseStyle['hidden-md-down'])}
                onClick={this.props.endPreview}
              >
                <span>End Preview</span>
              </Clickable>
              <input
                type="image"
                aria-label="End student preview"
                className={classnames(style.backIcon, lessThan.medium ? null : style.hideCloseBtn)}
                data-test-id="endPreviewIconBtnMobile"
                src={closeIcon}
                onClick={this.props.endPreview}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }

  renderFooter () {
    let splitPaneSmallStyle = ''
    if (this.props.browser.lessThan.medium ||
      (this.state.splitPane && (this.state.splitLeftFooterWidth === '50%')) ||
      (this.state.splitPane && (window.innerWidth - this.state.splitLeftFooterWidth) <= 768)) {
      splitPaneSmallStyle = this.state.splitPane ? style.splitPaneContainer : ''
      return (
        <FooterBar
          splitPane={this.state.splitPane}
          width={this.state.splitLeftFooterWidth}
          className={baseStyle.footer}
        >
          <button
            className={classnames('btn-cdl-main', style.beginActivityButton, splitPaneSmallStyle)}
            onClick={this.onActivityClick.bind(this)}
          >
            {this.renderStartText()}
          </button>
        </FooterBar>
      )
    } else {
      return (
        <FooterBar
          splitPane={this.state.splitPane}
          legacyEbook={this.props.uiState.isLegacyEbookDisplayed}
          width={this.state.splitLeftFooterWidth}
        >

          {/* Button component in footer to start the activity
           this role = button should be substituted for a better fix in the future, other fixes slowed down nav */}
          <AutoFocus>
            <CenterRoundButton
              data-test-id="beginActivityBtn"
              className="beginActivityButton"
              onClick={this.onActivityClick.bind(this)}
            >
              {this.renderStartText()}
            </CenterRoundButton>
          </AutoFocus>
        </FooterBar>
      )
    }
  }

  renderDefaultPage () {
    const splitOverride = this.state.splitPane ? style.splitOverride : ''
    const splitPanelOverride = this.state.splitPane ? style.splitPanelOverride : ''
    const splitPaneStyle = this.state.splitPane && this.state.splitLeftFooterWidth >= 768
      ? style.splitContainer
      : ''

    /* this is horrible and needs to be refactored - tdoug.  Written by: tdoug */
    let activityTopBarSpace = this.state.splitPane ? null : baseStyle.activityTopBarSpace
    activityTopBarSpace = this.props.previewMode
      ? baseStyle.pspPreviewTopBarSpace
      : activityTopBarSpace
    activityTopBarSpace = (this.props.previewMode && this.state.splitPane)
      ? baseStyle.SplitPreviewSpace
      : activityTopBarSpace

    return (
      <div className={activityTopBarSpace}>
        {this.state.howIsCalculatedModel && <HowIsCalculatedModal
          type={'Estimated'}
          onClose={() => this.setState({ howIsCalculatedModel: false })}
        />}
        {this.props.uiState.showArgaError
          ? <ArgaErrorBar
            isPreview={this.props.previewMode}
          />
          : null}
        <Grid
          className={
            classnames(style.innerContent, splitOverride,
              splitPaneStyle, { [style.previewBarSpacer]: this.props.previewMode })
          }
        >
          <Row>
            <Col
              sm={this.props.browser.width === 768 ? 12 : 6}
              className={classnames(style.panelContainer, splitPanelOverride)}
            >
              <ProgressArea
                completedTimestamp={this.props.activity.completedTimestamp}
                activityScore={this.props.activity.score.activityScore}
                scoreTarget={this.props.activity.score.scoreTarget}
                browser={this.props.browser}
                splitPane={this.state.splitPane}
                ffEstimatedTimeToCompleteEnabled={this.props.ffEstimatedTimeToCompleteEnabled}
                courseAvgTime={this.props.activity.courseAvgTime}
                courseEstTime={this.props.activity.courseEstTime}
                openHowIsCalculatedModal={() => this.setState({ howIsCalculatedModel: true })}
              />
            </Col>
            {this.props.activity.config.noPsp ? null : this.renderPersonalizedStudyPlan()}
          </Row>
        </Grid>
        {this.renderFooter()}
      </div>
    )
  }

  renderSplitPane () {
    return (
      <LCSplitPane
        isLegacyEbook={this.props.uiState.isLegacyEbookDisplayed}
        isPreview={this.props.previewMode}
        browser={this.props.browser}
        toggle={this.onToggleEbook.bind(this)}
        isLanding={true}
        PSPItem={this.state.EbookPspItem}
        outerFooterCalc={this.onResizeSplit.bind(this)}
        lastWidth={this.state.splitLeftFooterWidth}
      >
        {this.renderDefaultPage()}
      </LCSplitPane>
    )
  }

  renderTopBar () {
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'
    return (
      <TopBar
        headerStyle={headerStyle}
        isPreview={this.props.previewMode}
        splitPane={this.state.splitPane}
      >
        {!isAchieve && <CloseX closeAction={this.closeActivity} />}
        {isAchieve ? this.achieveHeader() : this.classicHeader()}
      </TopBar>
    )
  }

  achieveHeader () {
    const label = this.props.browser.lessThan.medium
      ? 'Tips'
      : 'LearningCurve Tips for Success'

    return (
      <Grid
        className={classnames(baseStyle.topBarWrapper, baseStyle.closeXSpace)}
      >
        <Row className={baseStyle.topBarRow}>
          <Col xs={9} sm={5} md={6} lg={7} className={style.pageTitleContainer} />
          <Col
            xs={3}
            sm={7}
            md={6}
            lg={5}
            className={baseStyle.topBarButtonContainer}
            role="navigation"
          >
            <div className={style.buttonContainer}>
              <Clickable
                className={style.achieveFaq}
                onClick={this.onFaqClick.bind(this)}
                tabIndex="0"
              >
                <span
                  data-test-id="showFaqPage"
                  className={baseStyle['hidden-md-down']}
                >
               Frequently Asked Questions
                </span>
              </Clickable>
              <button
                data-test-id="tipsForSuccessBtn"
                className="btn-cdl-secondary"
                onClick={this.onTipsClick.bind(this)}
                tabIndex="0"
              >
                {label}
              </button>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }

  classicHeader () {
    const label = this.props.browser.lessThan.medium
      ? 'Tips'
      : 'LearningCurve Tips for Success'

    return (
      <Grid
        className={classnames(baseStyle.topBarWrapper, baseStyle.closeXSpace)}
      >
        <Row className={baseStyle.topBarRow}>
          <Col xs={9} sm={5} md={6} lg={7} className={style.pageTitleContainer}>
            <h1
              data-test-id="pageTitle"
              className={style.pageTitle}
              tabIndex="0"
              style={{ fontSize: this.props.browser.lessThan.medium ? 14 : 18 }}
            >
              <TextTruncate
                text={this.props.activity.activityTitle}
                line={2}
                browser={this.props.browser}
              />
            </h1>
          </Col>
          <Col
            xs={3}
            sm={7}
            md={6}
            lg={5}
            className={baseStyle.topBarButtonContainer}
            role="navigation"
          >
            <div className={style.buttonContainer}>
              <Clickable
                className={style.faq}
                onClick={this.onFaqClick.bind(this)}
                tabIndex="0"
              >
                <span
                  data-test-id="showFaqPage"
                  className={baseStyle['hidden-md-down']}
                >
               Frequently Asked Questions
                </span>
              </Clickable>
              <button
                data-test-id="tipsForSuccessBtn"
                className="btn-cdl-main"
                onClick={this.onTipsClick.bind(this)}
                tabIndex="0"
              >
                {label}
              </button>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }

  render () {
    this.setDocumentTitle()

    // this needs to redirect when "back to study plan is clicked"
    // this is broken until we fit the LCRP quiz inside a LandingPage component
    if (this.props.paused) {
      // exit out of LandingPage component state in LCRP
    }

    if (!this.props.activity) {
      return null
    }

    if (this.props.uiState.showFaqPage) {
      return (
        <StudentFAQ
          onClick={this.onFaqClick.bind(this)}
          browser={this.props.browser}
          headerStyle={this.props.activity.config.headerStyle}
        />
      )
    }

    if (this.props.browser.lessThan.medium && this.props.uiState.isSplitScreenEbookDisplayed &&
      !this.props.activity.score.curCard) {
      window.scrollTo(0, 0)
      return (
        <EbookSplitMobile
          onClick={this.onToggleEbook.bind(this)}
          PSPItem={this.state.EbookPspItem}
          isPreview={this.props.previewMode}
        />
      )
    }

    if (!this.props.paused && this.props.activity.score.curCard) {
      return (
        <div>
          {this.props.activity.config.testMode ? this.renderPreviewModeMeta() : null}
          {this.props.previewMode
            ? <PreviewBar exitClick={this.props.endPreview} browser={this.props.browser} />
            : null}
          <Activity
            browser={this.props.browser}
            uiState={this.props.uiState}
            coach={this.props.coach}
            score={this.props.activity.score}
            actions={this.props.actions}
            activityTitle={this.props.activity.activityTitle}
            activityTopics={this.props.activity.allTopics}
            simulateLCRP={this.props.activity.config.simulateLCRP}
            isPreview={this.props.previewMode}
          />
          {this.props.uiState.isShowNetworkIssueModalDisplayed && <NetworkIssueModal
            onClose={() => this.props.actions.closeNetworkIssueModal()}
          />}
        </div>
      )
    }

    window.scrollTo(0, 0)
    const splitMargin = this.state.splitPane ? style.splitMargin : ''

    return (
      <div className={classnames(style.container, splitMargin)}>
        {this.props.previewMode
          ? <PreviewBar exitClick={this.props.endPreview} browser={this.props.browser} />
          : null}
        {this.props.activity.config.headerStyle !== 'hidden' && this.renderTopBar()}
        <div {...(this.props.activity.config.headerStyle !== 'achieve' ? { role: 'main' } : {})}>
          {this.state.splitPane ? this.renderSplitPane() : this.renderDefaultPage()}
          {this.props.uiState.isShowNetworkIssueModalDisplayed && <NetworkIssueModal
            onClose={() => this.props.actions.closeNetworkIssueModal()}
          />}
          {this.props.uiState.isTipsForSuccessModalDisplayed
            ? <TipsForSuccessModal
              onCancel={this.props.actions.closeTipsForSuccess}
              faqClick={this.props.actions.faq}
            />
            : null}
          {this.props.uiState.isEbookModalDisplayed
            ? <EbookModal
              data={this.props.uiState.ebookModalDisplayValue}
              onClick={this.props.actions.closeEbookModal}
            />
            : null
          }
        </div>
      </div>
    )
  }
}

LandingPage.propTypes = {
  browser: PropTypes.object,
  activity: PropTypes.object,
  uiState: PropTypes.object,
  coach: PropTypes.object,
  activityFile: PropTypes.string,
  paused: PropTypes.bool.isRequired,
  waiting: PropTypes.bool.isRequired,
  previewMode: PropTypes.bool,
  endPreview: PropTypes.func,
  actions: actionProptypes
}

function mapStateToProps (state, ownProps) {
  return {
    browser: state.browser,
    activity: state.core.activity,
    uiState: state.core.uiState,
    coach: state.coach,
    paused: state.paused,
    waiting: state.waiting,
    activityFile: state.routing.locationBeforeTransitions.query.file, // from launchpad
    showAboutPage: state.aboutLearningCurve,
    previewMode: previewMode || ownProps.previewMode,
    ffEstimatedTimeToCompleteEnabled: state.core.consul && state.core.consul.FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED === 'true'
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return { actions: bindActionCreators(actionCreators, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage)
